class AboutWorkspace extends HTMLElement {
	connectedCallback() {
		this.setup();
	}
	setup() {
		this.cloneUntilWidthExceeds();

		new MasterTimeline({
			triggerInit: this,
			scrollTrigger: { trigger: this.querySelector(".about-workspace") },
			tweenArr: [
				...Array.from(this.querySelectorAll(".about-workspace-content-item")).map((el, idx, args) => {
					return new FadeIn({
						el,
						from: { y: "50%" },
					});
				}),
			],
		});

		this.newInteract();
	}

	cloneUntilWidthExceeds() {
		const itemWrap = this.querySelector(".about-workspace-content-inner");
		const itemGrp = this.querySelector(".about-workspace-content-grps");

		const cloneTimes = Math.ceil(window.innerWidth / itemGrp.clientWidth) + 2;
		for (let i = 0; i < cloneTimes; i++) {
			const clone = itemGrp.cloneNode(true);
			itemWrap.appendChild(clone);
		}
	}
	newInteract() {
		let maxDistance = this.querySelector('.about-workspace-content-grps').clientWidth;
		let speed = maxDistance / 1000;
		let timeScale = { value : 1}
		let dragVelo = { value : 0 }
		let marquee = this.querySelector('.about-workspace-content-inner');
		let direction = -1;

		let startX = 0;
		let distance = 0;
		let isDragging = false;
		const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

		const startEvent = isTouchDevice ? 'touchstart' : 'pointerdown';
		const moveEvent = isTouchDevice ? 'touchmove' : 'pointermove';
		const endEvent = isTouchDevice ? 'touchend' : 'pointerup';

		marquee.addEventListener(startEvent, (e) => {
			isDragging = true;
			gsap.to(timeScale, {value: 0, duration: 1});
			startX = isTouchDevice ? e.touches[0].clientX : e.clientX;
			marquee.addEventListener(moveEvent, onMouseMove);
		});

		window.addEventListener(endEvent, () => {
			if (!isDragging) return;
			isDragging = false;
			dragVelo.value = distance;
			gsap.to(dragVelo, {value: 0, duration: 1, ease: 'power2.out'});
			gsap.to(timeScale, {value: 1, duration: 1, ease: 'power2.out'});
			distance = 0;
			marquee.removeEventListener(moveEvent, onMouseMove);
		});

		function onMouseMove(e) {
			distance = isTouchDevice ? e.targetTouches[0].clientX - startX : e.clientX - startX;
			startX = isTouchDevice ? e.targetTouches[0].clientX : e.clientX;
			if (distance > 0) {
				direction = 1;
			} else {
				direction = -1;
			}
		}
		
		function loop() {
			let currX = xGetter(marquee);
			let xTarget;
			if (currX < -maxDistance || currX > maxDistance) {
				xTarget = 0;
			} else {
				if (distance !== 0) {
					xTarget = currX + distance;
					distance = lerp(distance, 0, 0.1);
				} else {
					xTarget = currX + speed * direction * timeScale.value + dragVelo.value;
				}
			}
			xSetter(marquee)(xTarget);
			requestAnimationFrame(loop);
		}
		requestAnimationFrame(loop);
	}
	interact() {
		let allowDrag = false;
		const wrapperList = this.querySelector(".about-workspace-content");
		const setterTransform = gsap.quickSetter(this.querySelector(".about-workspace"), "--x-slide", "%");
		let translateValue = 0;
		let dragStartValue = 0;
		let direction = 1;
		let speed = 1;
		const threshold = getScreenType().isDesktop ? 6 : 3;
		let translateX;
		let decelerating = false;
		let accelerating = false;
		let reset = false;
		let decelerationFactor = 0.075;
		let accelerationFactor = 0.3; 
		let amplitude = 1;  

		const handleResetMove = () => { 
			if (getScreenType().isDesktop) {
				if (this.querySelector(".about-workspace-content-inner:hover")) {
					// Do nothing
				} else {
					allowDrag = false;
				}
			}
			requestAnimationFrame(handleResetMove);
		}	
		requestAnimationFrame(handleResetMove); 

		const handleUpdateTranslate = e => { 
			if (!allowDrag) return;
			translateX = (e.clientX || e.changedTouches[0].clientX) - dragStartValue;  
			amplitude = Math.min(8, Math.max(1, Math.abs(translateX / 2)))

			translateValue += (translateX / window.innerWidth) * 100;
			dragStartValue = e.clientX || e.changedTouches[0].clientX;
			if (Math.abs(translateX) > threshold) {
				direction = translateX > 0 ? 1 : -1;
				changeDirection();
			}
			setterTransform(dragStartValue % 100); 
		};
		const changeDirection = () => {
			decelerating = true;
			direction *= -1;
		};

		wrapperList.addEventListener("pointerdown", e => {
			allowDrag = true;
			decelerating = true;
			accelerating = false;
			dragStartValue = e.clientX;
		});

		wrapperList.addEventListener("pointerup", e => {
			allowDrag = false;
			decelerating = false;
			accelerating = true;
		});

		wrapperList.addEventListener("pointermove", handleUpdateTranslate);

		wrapperList.addEventListener("touchstart", e => {
			allowDrag = true;
			dragStartValue = e.changedTouches[0].clientX;
		});
		wrapperList.addEventListener("touchend", e => {
			allowDrag = false;
		});
		wrapperList.addEventListener("touchmove", handleUpdateTranslate);

		const loop = () => { 
			if (!isInViewport(this) || allowDrag) {
				setterTransform(translateValue % 100);
			} else {
				if (getScreenType().isDesktop) { 
					if (decelerating) {
						speed = Math.max(0, speed - decelerationFactor); 
						if (speed <= 0) {
							decelerating = false;
							accelerating = true;
						}
						} else if (accelerating) {
							speed = speed + accelerationFactor;
							if (speed >= amplitude) { 
								accelerating = false;
								reset = true;
							}
						} else if (reset) {
							speed = Math.min(amplitude, speed - decelerationFactor * 2);		
							if (speed <= 1) {
								reset = false;
						}
					}
				}
				translateValue -= 0.15 * direction * speed;
				setterTransform(translateValue % 100); 
			}
			requestAnimationFrame(loop);
		}; 
		
		loop.bind(this)();
	}
}

customElements.define("about-workspace", AboutWorkspace);
